<template>
  <page :name="$t('Le mie skill')">
    <template #header>
        {{ $t('Segnalaci qui le tue skill principali. Le utilizzeremo per inviarti nuove opportunità di lavoro.') }}
    </template>
    <pf-page-section no-body-wrapper>
      <p>{{ $t('Cerchiamo sempre la massima collaborazione con i nostri partner. Spesso alcuni clienti ci chiedono soluzioni che vanno al di là del nostro core business, hosting & cloud server, di conseguenza cerchiamo di metterli in contatto con i nostri partner per agevolare una collaborazione e soddisfare la loro esigenza.') }}</p>
      <p>{{ $t('Compilando questo form potrai segnalarci le tue skill e abilità. Non appena il nostro sistema troverà un match ti metteremo in diretto contatto con il richiedente. Artera in nessun caso pretenderà una commissione e lascierà a voi libera trattativa.') }}</p>
    </pf-page-section>

    <pf-page-section>
      <skill-form />
    </pf-page-section>
  </page>
</template>

<script lang="ts" setup>
import SkillForm from '../components/skill-form.vue';
</script>
